import React from 'react';
import { EyeIcon, ClockIcon, BadgeCheck } from 'lucide-react';
const HeaderGlpPlateau3 = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-18010">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-18011"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-18012">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-18013">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-18014">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-18015">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-18016">
          <div className="text-left" data-id="element-18017">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-18018">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-18019">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-18020">
        <div className="max-w-4xl mx-auto" data-id="element-18021">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-18022">
            GLP-1 NEWS
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-2" data-id="element-18023">
            Dr. Reed: Why Your Body Is Fighting Your GLP-1 — And How To Stop It
          </h1>
          <p className="text-sm sm:text-base text-gray-500 italic mb-6" data-id="element-18024">
            (From a Metabolic Specialist Who Spent 18 Months Trying To Solve Her
            Own Plateau)
          </p>

          {/* Author Byline */}
          <div className="flex items-center gap-4 mb-6 pb-5 border-b border-gray-200" data-id="element-18025">
            <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0 bg-gray-200" data-id="element-18026">
              <img src="https://cdn.magicpatterns.com/uploads/njKHWtEUNXzL7WtDqVKiu5/pasted-image.jpg" alt="Dr. Patricia Reed" className="w-full h-full object-cover" data-id="element-18027" />
            </div>
            <div className="flex-1" data-id="element-18028">
              <div className="flex items-center gap-2 mb-2" data-id="element-18029">
                <span className="text-base font-medium text-gray-900" data-id="element-18030">
                  Written by Dr. Patricia Reed
                </span>
                <BadgeCheck className="h-5 w-5 text-blue-600" data-id="element-18031" />
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-18032">
                Verified Metabolic Health Specialist, Cedar Sinai Medical Center
              </div>
              <div className="flex items-center gap-4 text-sm text-gray-500" data-id="element-18033">
                <div className="flex items-center gap-1" data-id="element-18034">
                  <ClockIcon className="h-4 w-4" data-id="element-18035" />
                  <span data-id="element-18036">7 min read</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-18037">
                  <EyeIcon className="h-4 w-4" data-id="element-18038" />
                  <span data-id="element-18039">171,892 views</span>
                </div>
              </div>
            </div>
          </div>

          <div className="my-4" data-id="element-18040">
            <img src="https://cdn.magicpatterns.com/uploads/nwn6hondxNojcsAjvGQfEj/2.png" alt="Before and after transformation" className="w-full rounded-lg shadow-lg mb-3" data-id="element-18041" />
            <div className="flex justify-between items-center px-2 py-1 bg-gray-50 rounded border-t border-gray-200" data-id="element-18042">
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-18043">
                September 25, 2021
              </span>
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-18044">
                December 7, 2025
              </span>
            </div>
          </div>

          <div className="mb-6" data-id="element-18045"></div>

          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-18046">
            Before you increase your dose, read this. If the scale has stopped
            moving, your body hasn't built a tolerance — it has hit a "stress
            threshold." Here's how to break through it, or prevent it from ever
            happening.
          </p>

          <div className="border-t border-gray-200 pt-3 mb-6 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-18047">
            <div className="mb-1 flex items-center" data-id="element-18048">
              <span className="font-medium mr-2" data-id="element-18049">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-18050">
              <span className="font-medium mr-2" data-id="element-18051">Published:</span>
              January 2026
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderGlpPlateau3;